import Icon from '../Icon.jsx';
import { ButtonLink, Check, ClosingBand, PageLabel } from '../parts.jsx';
import { appLinks } from '../navigation.js';

const newJobs = [
  { icon: 'droplets', title: 'Fix a leaking bathroom tap', line: 'Birmingham, B6 · 2 photos' },
  { icon: 'lightbulb', title: 'Ceiling light buzzing', line: 'Birmingham, B6 · 1 photo' },
];

const stages = [
  { name: 'New requests', cards: [
    { title: 'Fix a leaking bathroom tap', line: 'Birmingham · respond by Friday' },
    { title: 'Ceiling light buzzing', line: 'Birmingham, B6 · respond by Thursday' },
  ] },
  { name: 'Quoted', cards: [{ title: 'Curtain pole coming loose', line: '£45 · sent today', status: { icon: 'hourglass', word: 'Waiting', tone: 'waiting' } }] },
  { name: 'Won', cards: [{ title: 'Dripping kitchen tap', line: 'Tomorrow at 10 · £85', status: { icon: 'check', word: 'Booked', tone: 'booked' } }] },
];

export default function ForBusinessesPage() {
  return <>
    <section className="mk-container mk-hero is-title-only" aria-labelledby="businesses-title">
      <PageLabel icon="store">For Businesses</PageLabel>
      <h1 className="mk-display" id="businesses-title">Find repair jobs near you.</h1>
    </section>

    <section className="mk-band is-sage is-48" id="for-trades-and-services" aria-labelledby="trades-title">
      <div className="mk-container mk-split is-centred">
        <div className="mk-split-copy is-520 is-gap-16">
          <h2 className="mk-h2 is-32" id="trades-title">For Trades &amp; Services</h2>
          <p className="mk-lead is-ink is-20">Receive requests. Send quotes. Win work.</p>
          <Check>No commission on jobs</Check>
          <div><ButtonLink to={appLinks.findJobs} size={56} big>Find jobs</ButtonLink></div>
        </div>
        <ul className="mk-job-rows">{newJobs.map((job) => <li key={job.title} className="mk-job-row">
          <span className="mk-icon-tile is-44 is-sage"><Icon name={job.icon} size={22}/></span>
          <span className="mk-job-row-text"><span className="mk-job-row-title">{job.title}</span><span className="mk-job-row-line">{job.line}</span></span>
          <span className="mk-job-row-action">Send quote</span>
        </li>)}</ul>
      </div>
    </section>

    <section className="mk-container mk-section" id="requests-quotes-and-won-work" aria-labelledby="pipeline-title">
      <h2 className="mk-h2" id="pipeline-title">Requests, Quotes and Won Work</h2>
      <div className="mk-pipeline">
        {stages.map((stage) => <div className="mk-stage" key={stage.name}>
          <h3 className="mk-stage-head"><span>{stage.name}</span><span className="mk-stage-count">{stage.cards.length}</span></h3>
          <ul className="mk-stage-cards">{stage.cards.map((card) => <li className="mk-stage-card" key={card.title}>
            <p className="mk-stage-card-title">{card.title}</p>
            <p className="mk-stage-card-line">{card.line}</p>
            {card.status && <p className={`mk-stage-status is-${card.status.tone}`}><Icon name={card.status.icon} size={14}/>{card.status.word}</p>}
          </li>)}</ul>
        </div>)}
      </div>
    </section>

    <ClosingBand title="Add Your Company" text="Create your company profile and find repair jobs near you. No commission on jobs." wideCopy>
      <ButtonLink to={appLinks.addCompany} variant="white" size={56}>Add your company</ButtonLink>
    </ClosingBand>
  </>;
}
